module.exports = __webpack_public_path__ + "static/media/zolaicons.fe888b17.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/zolaicons.svg?24613844
 ** module id = 614
 ** module chunks = 50
 **/